'use strict';
import request from '@/utils/request';
class PaymentService{
    static list(query){
        return request({
            url:'/payment/savings-accounts',
            method:'get',
            params:query
        })
    }

    static listSavingAcount(query){
        return request({
            url:'/payment/method-payment',
            method:'get',
            params:query
        });
    }
    static PayChecked(data){
        return request({
            url:'/payment/checkout-online',
            method:'post',
            data
        })
    }
    static Pay(data){
        return request({
            url:'/payment/checkout-online',
            method:'post',
            timeout:60000,
            data
        })
    }
    static addMethodPay(data){
        return request({
            url:'/payment/add-method',
            method:'post',
            data
        })
    }
    static listMethodPay(query){
        return request({
            url:'/payment/method-list',
            method:'get',
            params:query
        })
    }
    static createSavingAcount(data){
        return request({
            url:'/payment/savings-accounts',
            method:'post',
            data
        });
    }
    static createMethod(data){
        return request({
            url:'/payment/method-payment',
            method:'post',
            timeout:60000,
            data
        })
    }
    static updateMethod(data){
        return request({
            url:'/payment/method-payment',
            method:'put',
            timeout:60000,
            data
        })
    }
    static deleteMethod(data){
        return request({
            url:'/payment/delete/method-payment',
            method:'put',
            timeout:60000,
            data
        })
    }
    static createTransaction(data){
        return request({
            url:'/payment/transaction',
            method:'post',
            timeout:60000,
            data
        })
    }
    static createCash(data){
        return request({
            url:'/payment/cash',
            method:'post',
            timeout:60000,
            data
        })
    }
}

export default PaymentService;
